import styled from 'styled-components'
import { DeviceTypes } from '../../types/state'

export const FooterWrapper = styled.div`
	// height: 130px;
	/* background-color: #16469c; */
	width: var(--w-10);
	box-shadow: 0px -6px 10px rgba(0, 0, 0, 0.29);
	margin-top: auto;
	position: sticky;
	bottom: 0;
`

export const ButtonText = styled.span`
	letter-spacing: 0.46px;
	font-size: var(--fs-sm);
	font-weight: var(--fw-md);
`
export const TnC = styled.span`
	text-decoration: underline;
	margin-left: 5px;
`

export const ButtonWrapper = styled.div<{ device: DeviceTypes }>`
	display: flex;
	justify-content: center;
	--btn-width: var(--w-8);
	--btn-width: ${({ device }) =>
		device === DeviceTypes.MOBILE ? '80%' : '30%'};
	--btn-bg-color: var(--btn-color);
	--btn-bg-disabled: var(--btn-color-disabled);
	--btn-text-color: var(--text-color);
	--btn-text-disabled: var(--text-color-disabled);
	--btn-border-radius: var(--border-radius-sm);
	--btn-height: var(--it-hg-lg);
	margin-bottom: 10px;
`

export const ArrowImg = styled.img`
	height: 12px;
	width: 12px;
`
